import { AUTO_IMPORT_PERIOD } from "../integrations/_components/ScheduledTasks/AutoImportPeriod";

const ADYEN = {
    identifier: "ADYEN",
    name: "Adyen",
    lowercaseIdentifier: "adyen",
    icon: "fas fa-euro-sign",
    integrationPath: "/adyen",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const AMAZON = {
    identifier: "AMAZON",
    name: "Amazon",
    icon: "fab fa-amazon",
    integrationPath: "/amazon",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const AMAZON_PAY = {
    identifier: "AMAZON_PAY",
    name: "Amazon Pay (alt)",
    lowercaseIdentifier: "amazonPay",
    icon: "fab fa-amazon",
    integrationPath: "/amazon/pay",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const AMAZON_PAY_V2 = {
    identifier: "AMAZON_PAY_V2",
    name: "Amazon Pay",
    lowercaseIdentifier: "amazonPayV2",
    icon: "fab fa-amazon",
    integrationPath: "/amazon/pay/v2",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const AMAZON_PAYOUT = {
    identifier: "AMAZON_PAYOUT",
    name: "Amazon Auszahlungen",
    lowercaseIdentifier: "amazonPayout",
    icon: "fab fa-amazon",
    integrationPath: "/amazon/payout",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.DAILY],
};
const AMAZON_ORDER = {
    identifier: "AMAZON_ORDER",
    name: "Amazon",
    lowercaseIdentifier: "amazonOrder",
    icon: "fab fa-amazon",
    integrationPath: "/amazon/order",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY],
};
const BAMBOO = {
    identifier: "BAMBOO",
    name: "Bamboo",
    icon: "",
    integrationPath: "/bamboo",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

const BILLBEE = {
    indentifier: "BILLBEE",
    name: "Billbee",
    lowercaseIdentifier: "billbee",
    icon: "",
    integrationPath: "/billbee",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

const HRCHANGEREPORT = {
    identifier: "HRCHANGEREPORT",
    name: "Lohn & Gehalt",
    icon: "fas fa-money-check-alt",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const BRAINTREE = {
    identifier: "BRAINTREE",
    name: "Braintree",
    lowercaseIdentifier: "braintree",
    icon: "fas fa-euro-sign",
    integrationPath: "/braintree",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const CHARGEBEE = {
    identifier: "CHARGEBEE",
    name: "Chargebee",
    lowercaseIdentifier: "chargebee",
    icon: "fa fa-file-invoice-dollar",
    integrationPath: "/chargebee",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const CHECKFRONT = {
    identifier: "CHECKFRONT",
    name: "Checkfront",
    icon: "fa fa-file-invoice-dollar",
    integrationPath: "/checkfront",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const FASTBILL = {
    identifier: "FASTBILL",
    name: "Fastbill",
    icon: "fa fa-file-invoice-dollar",
    integrationPath: "/fastbill",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const GOCARDLESS = {
    identifier: "GOCARDLESS",
    name: "GoCardless",
    lowercaseIdentifier: "gocardless",
    icon: "fas fa-euro-sign",
    integrationPath: "/gocardless",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const KLARNA = {
    identifier: "KLARNA",
    name: "Klarna",
    lowercaseIdentifier: "klarna",
    icon: "fas fa-euro-sign",
    integrationPath: "/klarna",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const LEX_OFFICE = {
    identifier: "LEX_OFFICE",
    name: "Lexoffice",
    icon: "fa fa-file-invoice-dollar",
    integrationPath: "/lexoffice",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const MOLLIE = {
    identifier: "MOLLIE",
    name: "Mollie",
    lowercaseIdentifier: "mollie",
    icon: "fas fa-file-invoice-dollar",
    integrationPath: "/mollie",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const OMR = {
    identifier: "OMR",
    name: "Online Marketing Rockstars",
    lowercaseIdentifier: "omr",
    icon: "fas fa-comment-alt",
    integrationPath: "/omr",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const PATHWAY_BILLING = {
    identifier: "PATHWAY_BILLING",
    name: "Rechnungsprinter",
    lowercaseIdentifier: "pathwayBilling",
    icon: "fas fa-file-invoice-dollar",
    integrationPath: "/pathway-billing",
    autoImportPeriods: [],
};
const PAYPAL = {
    identifier: "PAYPAL",
    name: "PayPal",
    lowercaseIdentifier: "paypal",
    icon: "fab fa-cc-paypal",
    integrationPath: "/paypal",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const SHOPIFY = {
    identifier: "SHOPIFY",
    name: "Shopify",
    lowercaseIdentifier: "shopifyOrder",
    icon: "fab fa-shopify",
    integrationPath: "/shopify",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

const SHOPIFY_V2 = {
    identifier: "SHOPIFY_V2",
    name: "Shopify V2",
    lowercaseIdentifier: "shopifyOrder",
    icon: "fab fa-shopify",
    integrationPath: "/shopify",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

const SHOPIFY_PAYMENTS = {
    identifier: "SHOPIFY_PAYMENTS",
    name: "Shopify Payments",
    lowercaseIdentifier: "shopifyPayments",
    icon: "fab fa-shopify",
    integrationPath: "/shopify/payments",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const SHOPIFY_POS = {
    identifier: "SHOPIFY_POS",
    name: "Shopify POS (Bar)",
    lowercaseIdentifier: "shopifyPos",
    icon: "fab fa-shopify",
    integrationPath: "/shopify/pos",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const SHOPWARE = {
    identifier: "SHOPWARE",
    name: "Shopware",
    lowercaseIdentifier: "shopware",
    icon: "fab fa-shopware",
    integrationPath: "/shopware",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const SNIPCART = {
    identifier: "SNIPCART",
    name: "Snipcart",
    lowercaseIdentifier: "snipcart",
    icon: "fa fa-cart-arrow-down",
    integrationPath: "/snipcart",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const STOREGANISE = {
    identifier: "STOREGANISE",
    name: "Storeganise",
    lowercaseIdentifier: "storeganise",
    icon: "fa fa-cart-arrow-down",
    integrationPath: "/storeganise",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const STRIPE = {
    identifier: "STRIPE",
    name: "Stripe",
    icon: "fab fa-cc-stripe",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const STRIPE_BILLING = {
    identifier: "STRIPE_BILLING",
    name: "Stripe Billing",
    lowercaseIdentifier: "stripeBilling",
    icon: "fab fa-cc-stripe",
    integrationPath: "/stripe/billing",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const STRIPE_PAYMENTS = {
    identifier: "STRIPE_PAYMENTS",
    name: "Stripe Payments",
    lowercaseIdentifier: "stripePayments",
    icon: "fab fa-cc-stripe",
    integrationPath: "/stripe/payments",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const SQUARESPACE = {
    identifier: "SQUARESPACE",
    name: "Squarespace",
    lowercaseIdentifier: "squarespace",
    icon: "fab fa-squarespace",
    integrationPath: "/squarespace",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const TIKTOK_PAYMENTS = {
    identifier: "TIKTOK_PAYMENTS",
    name: "TikTok Payments",
    lowercaseIdentifier: "tiktokPayments",
    icon: "fab fa-tiktok",
    integrationPath: "/tiktok/payments",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const TIKTOK_SHOP = {
    identifier: "TIKTOK_SHOP",
    name: "TikTok Shop",
    lowercaseIdentifier: "tiktokShop",
    icon: "fab fa-tiktok",
    integrationPath: "/tiktok/shop",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const ABOUT_YOU = {
    identifier: "ABOUT_YOU",
    name: "About You",
    lowercaseIdentifier: "aboutYou",
    icon: "fa fa-shopping-bag",
    integrationPath: "/aboutyou",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const ABOUT_YOU_PAYMENTS = {
    identifier: "ABOUT_YOU_PAYMENTS",
    name: "About You Payments",
    lowercaseIdentifier: "aboutYouPayments",
    icon: "fa fa-shopping-bag",
    integrationPath: "/aboutyou/payments",
    autoImportPeriods: [],
};
const EBAY = {
    identifier: "EBAY",
    name: "eBay",
    lowercaseIdentifier: "ebay",
    icon: "fab fa-ebay",
    integrationPath: "/ebay",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const EBAY_PAYMENTS = {
    identifier: "EBAY_PAYMENTS",
    name: "eBay Payments",
    lowercaseIdentifier: "ebayPayments",
    icon: "fab fa-ebay",
    integrationPath: "/ebay/payments",
    autoImportPeriods: [],
};
const OTTO = {
    identifier: "OTTO",
    name: "Otto",
    lowercaseIdentifier: "otto",
    icon: "fa fa-shopping-bag",
    integrationPath: "/otto",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const OTTO_PAYMENTS = {
    identifier: "OTTO_PAYMENTS",
    name: "Otto Payments",
    lowercaseIdentifier: "ottoPayments",
    icon: "fa fa-shopping-bag",
    integrationPath: "/otto/payments",
    autoImportPeriods: [],
};
const KAUFLAND = {
    identifier: "KAUFLAND",
    name: "Kaufland",
    lowercaseIdentifier: "kaufland",
    icon: "fa fa-shopping-bag",
    integrationPath: "/kaufland",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const KAUFLAND_PAYMENTS = {
    identifier: "KAUFLAND_PAYMENTS",
    name: "Kaufland Payments",
    lowercaseIdentifier: "kauflandPayments",
    icon: "fa fa-shopping-bag",
    integrationPath: "/kaufland/payments",
    autoImportPeriods: [],
};
const UNZER = {
    identifier: "UNZER",
    name: "Unzer",
    lowercaseIdentifier: "unzer",
    icon: "fa fa-cart-arrow-down",
    integrationPath: "/unzer",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const WOO_COMMERCE = {
    identifier: "WOO_COMMERCE",
    name: "WooCommerce",
    lowercaseIdentifier: "wooCommerce",
    icon: "fa fa-cart-arrow-down",
    integrationPath: "/woocommerce",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const ZALANDO = {
    identifier: "ZALANDO",
    name: "Zalando",
    lowercaseIdentifier: "zalando",
    icon: "fa fa-shopping-bag",
    integrationPath: "/zalando",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};
const ZALANDO_PAYMENTS = {
    identifier: "ZALANDO_PAYMENTS",
    name: "Zalando Payments",
    lowercaseIdentifier: "zalandoPayments",
    icon: "fa fa-shopping-bag",
    integrationPath: "/zalando/payments",
    autoImportPeriods: [],
};

const VETEVO = {
    identifier: "VETEVO",
    name: "Vetevo",
    icon: "",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

const WECLAPP = {
    identifier: "WECLAPP",
    name: "Weclapp",
    icon: "",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

const XENTRAL = {
    identifier: "XENTRAL",
    name: "Xentral",
    icon: "fa fa-cart-arrow-down",
    autoImportPeriods: [AUTO_IMPORT_PERIOD.MONTHLY, AUTO_IMPORT_PERIOD.WEEKLY, AUTO_IMPORT_PERIOD.DAILY],
};

export const Integration = {
    ABOUT_YOU,
    ABOUT_YOU_PAYMENTS,
    ADYEN,
    AMAZON,
    AMAZON_PAY,
    AMAZON_PAY_V2,
    AMAZON_PAYOUT,
    AMAZON_ORDER,
    BAMBOO,
    BILLBEE,
    BRAINTREE,
    CHARGEBEE,
    CHECKFRONT,
    EBAY,
    EBAY_PAYMENTS,
    FASTBILL,
    GOCARDLESS,
    HRCHANGEREPORT,
    KAUFLAND,
    KAUFLAND_PAYMENTS,
    KLARNA,
    LEX_OFFICE,
    MOLLIE,
    OMR,
    OTTO,
    OTTO_PAYMENTS,
    PATHWAY_BILLING,
    PAYPAL,
    SHOPIFY,
    SHOPIFY_V2,
    SHOPIFY_PAYMENTS,
    SHOPIFY_POS,
    SHOPWARE,
    SNIPCART,
    STOREGANISE,
    STRIPE,
    STRIPE_PAYMENTS,
    STRIPE_BILLING,
    SQUARESPACE,
    TIKTOK_PAYMENTS,
    TIKTOK_SHOP,
    UNZER,
    WOO_COMMERCE,
    VETEVO,
    WECLAPP,
    XENTRAL,
    ZALANDO,
    ZALANDO_PAYMENTS,
};
export const IntegrationName = {
    ABOUT_YOU: ABOUT_YOU.name,
    ABOUT_YOU_PAYMENTS: ABOUT_YOU_PAYMENTS.name,
    ADYEN: ADYEN.name,
    AMAZON: AMAZON.name,
    AMAZON_PAY: AMAZON_PAY.name,
    AMAZON_PAY_V2: AMAZON_PAY_V2.name,
    AMAZON_PAYOUT: AMAZON_PAYOUT.name,
    AMAZON_ORDER: AMAZON_ORDER.name,
    BAMBOO: BAMBOO.name,
    BILLBEE: BILLBEE.name,
    BRAINTREE: BRAINTREE.name,
    CHARGEBEE: CHARGEBEE.name,
    EBAY: EBAY.name,
    EBAY_PAYMENTS: EBAY_PAYMENTS.name,
    FASTBILL: FASTBILL.name,
    GOCARDLESS: GOCARDLESS.name,
    CHECKFRONT: CHECKFRONT.name,
    HRCHANGEREPORT: HRCHANGEREPORT.name,
    KAUFLAND: KAUFLAND.name,
    KAUFLAND_PAYMENTS: KAUFLAND_PAYMENTS.name,
    KLARNA: KLARNA.name,
    LEX_OFFICE: LEX_OFFICE.name,
    MOLLIE: MOLLIE.name,
    OMR: OMR.name,
    OTTO: OTTO.name,
    OTTO_PAYMENTS: OTTO_PAYMENTS.name,
    PATHWAY_BILLING: PATHWAY_BILLING.name,
    PAYPAL: PAYPAL.name,
    SHOPIFY: SHOPIFY.name,
    SHOPIFY_V2: SHOPIFY_V2.name,
    SHOPIFY_PAYMENTS: SHOPIFY_PAYMENTS.name,
    SHOPIFY_POS: SHOPIFY_POS.name,
    SHOPWARE: SHOPWARE.name,
    SNIPCART: SNIPCART.name,
    STOREGANISE: STOREGANISE.name,
    STRIPE: STRIPE.name,
    STRIPE_PAYMENTS: STRIPE_PAYMENTS.name,
    STRIPE_BILLING: STRIPE_BILLING.name,
    SQUARESPACE: SQUARESPACE.name,
    TIKTOK_PAYMENTS: TIKTOK_PAYMENTS.name,
    TIKTOK_SHOP: TIKTOK_SHOP.name,
    UNZER: UNZER.name,
    WOO_COMMERCE: WOO_COMMERCE.name,
    VETEVO: VETEVO.name,
    WECLAPP: WECLAPP.name,
    XENTRAL: XENTRAL.name,
    ZALANDO: ZALANDO.name,
    ZALANDO_PAYMENTS: ZALANDO_PAYMENTS.name,
};
export const IntegrationIdentifier = {
    ABOUT_YOU: ABOUT_YOU.identifier,
    ABOUT_YOU_PAYMENTS: ABOUT_YOU_PAYMENTS.identifier,
    ADYEN: ADYEN.identifier,
    AMAZON: AMAZON.identifier,
    AMAZON_PAY: AMAZON_PAY.identifier,
    AMAZON_PAY_V2: AMAZON_PAY_V2.identifier,
    AMAZON_PAYOUT: AMAZON_PAYOUT.identifier,
    AMAZON_ORDER: AMAZON_ORDER.identifier,
    BAMBOO: BAMBOO.identifier,
    BILLBEE: BILLBEE.identifier,
    BRAINTREE: BRAINTREE.identifier,
    CHARGEBEE: CHARGEBEE.identifier,
    EBAY: EBAY.identifier,
    EBAY_PAYMENTS: EBAY_PAYMENTS.identifier,
    GOCARDLESS: GOCARDLESS.identifier,
    CHECKFRONT: CHECKFRONT.identifier,
    HRCHANGEREPORT: HRCHANGEREPORT.identifier,
    KAUFLAND: KAUFLAND.identifier,
    KAUFLAND_PAYMENTS: KAUFLAND_PAYMENTS.identifier,
    KLARNA: KLARNA.identifier,
    MOLLIE: MOLLIE.identifier,
    OMR: OMR.identifier,
    OTTO: OTTO.identifier,
    OTTO_PAYMENTS: OTTO_PAYMENTS.identifier,
    PATHWAY_BILLING: PATHWAY_BILLING.identifier,
    PAYPAL: PAYPAL.identifier,
    SHOPIFY: SHOPIFY.identifier,
    SHOPIFY_PAYMENTS: SHOPIFY_PAYMENTS.identifier,
    SHOPIFY_POS: SHOPIFY_POS.identifier,
    SHOPWARE: SHOPWARE.identifier,
    SNIPCART: SNIPCART.identifier,
    STOREGANISE: STOREGANISE.identifier,
    STRIPE: STRIPE.identifier,
    STRIPE_PAYMENTS: STRIPE_PAYMENTS.identifier,
    STRIPE_BILLING: STRIPE_BILLING.identifier,
    TIKTOK_PAYMENTS: TIKTOK_PAYMENTS.identifier,
    TIKTOK_SHOP: TIKTOK_SHOP.identifier,
    UNZER: UNZER.identifier,
    WOO_COMMERCE: WOO_COMMERCE.identifier,
    VETEVO: VETEVO.identifier,
    WECLAPP: WECLAPP.identifier,
    XENTRAL: XENTRAL.identifier,
    ZALANDO: ZALANDO.identifier,
    ZALANDO_PAYMENTS: ZALANDO_PAYMENTS.identifier,
};

export const IntegrationIcon = {
    ABOUT_YOU: ABOUT_YOU.icon,
    ABOUT_YOU_PAYMENTS: ABOUT_YOU_PAYMENTS.icon,
    ADYEN: ADYEN.icon,
    AMAZON: AMAZON.icon,
    AMAZON_PAY: AMAZON_PAY.icon,
    AMAZON_PAYOUT: AMAZON_PAYOUT.icon,
    AMAZON_ORDER: AMAZON_ORDER.icon,
    BRAINTREE: BRAINTREE.icon,
    CHARGEBEE: CHARGEBEE.icon,
    EBAY: EBAY.icon,
    EBAY_PAYMENTS: EBAY_PAYMENTS.icon,
    GOCARDLESS: GOCARDLESS.icon,
    CHECKFRONT: CHECKFRONT.icon,
    HRCHANGEREPORT: HRCHANGEREPORT.icon,
    KAUFLAND: KAUFLAND.icon,
    KAUFLAND_PAYMENTS: KAUFLAND_PAYMENTS.icon,
    KLARNA: KLARNA.icon,
    MOLLIE: MOLLIE.icon,
    OMR: OMR.icon,
    OTTO: OTTO.icon,
    OTTO_PAYMENTS: OTTO_PAYMENTS.icon,
    PATHWAY_BILLING: PATHWAY_BILLING.icon,
    PAYPAL: PAYPAL.icon,
    SHOPIFY: SHOPIFY.icon,
    SHOPIFY_PAYMENTS: SHOPIFY_PAYMENTS.icon,
    SHOPIFY_POS: SHOPIFY_POS.icon,
    SHOPWARE: SHOPWARE.icon,
    SNIPCART: SNIPCART.icon,
    STOREGANISE: STOREGANISE.icon,
    STRIPE: STRIPE.icon,
    STRIPE_PAYMENTS: STRIPE_PAYMENTS.icon,
    STRIPE_BILLING: STRIPE_BILLING.icon,
    WOO_COMMERCE: WOO_COMMERCE.icon,
    XENTRAL: XENTRAL.icon,
    ZALANDO: ZALANDO.icon,
    ZALANDO_PAYMENTS: ZALANDO_PAYMENTS.icon,
};

// Soft brand tint per integration family, used by the dashboard status tags.
// These are provider brand colours and deliberately sit outside the --pw-*
// palette — they identify the integration, they are not design-system colour.
// Lives here rather than in the dashboard because it is integration data, next
// to IntegrationIcon.
const INTEGRATION_TAG_COLORS = {
    amazon: { bg: "#fff4dc", fg: "#8a5a00" },
    shopifyPayments: { bg: "#e1ecff", fg: "#2a4ea0" },
    shopify: { bg: "#e6f7ed", fg: "#1f6b3f" },
    stripe: { bg: "#efe7ff", fg: "#5b3fb0" },
    paypal: { bg: "#e1ecff", fg: "#1b3a7a" },
    klarna: { bg: "#ffe6f2", fg: "#9c2a6b" },
    woo: { bg: "#f3e8ff", fg: "#6b3fa0" },
    mollie: { bg: "#ffeede", fg: "#8a4b00" },
};

const NEUTRAL_TAG_COLOR = { bg: "var(--pw-neutral-100)", fg: "var(--pw-neutral-800)" };

// Matched by family, not by exact identifier, so AMAZON_PAYOUT and AMAZON_ORDER
// share Amazon's tint. Order matters: SHOPIFY_PAYMENTS must be tested before
// SHOPIFY.
export const getIntegrationTagColor = (integration) => {
    const key = (integration || "").toLowerCase();

    if (key.includes("amazon")) return INTEGRATION_TAG_COLORS.amazon;
    if (key.includes("shopify") && key.includes("pay")) return INTEGRATION_TAG_COLORS.shopifyPayments;
    if (key.includes("shopify")) return INTEGRATION_TAG_COLORS.shopify;
    if (key.includes("stripe")) return INTEGRATION_TAG_COLORS.stripe;
    if (key.includes("paypal")) return INTEGRATION_TAG_COLORS.paypal;
    if (key.includes("klarna")) return INTEGRATION_TAG_COLORS.klarna;
    if (key.includes("woo")) return INTEGRATION_TAG_COLORS.woo;
    if (key.includes("mollie")) return INTEGRATION_TAG_COLORS.mollie;

    return NEUTRAL_TAG_COLOR;
};
